const barStyle = {
    display: "inline-block",
    width: 4,
    margin: "0 1px",
    background: "#1DB954",
    borderRadius: 2,
    animation: "playingBar 1s infinite",
};

const containerStyle = {
    display: "flex",
    alignItems: 'center',
    height: 18,
    marginLeft: 8,
    marginRight: 10,
};

export default function CurrentlyPlayingAnimation({isPaused}) {

    barStyle.background = isPaused ? '#6b6b6b' : "#1DB954"

    return (
        <span style={containerStyle}>
            <span style={{ ...barStyle, height: 4, animationDelay: "0s" }} />
            <span style={{ ...barStyle, height: 7, animationDelay: "0.2s" }} />
            <span style={{ ...barStyle, height: 9, animationDelay: "0.4s" }} />
            <span style={{ ...barStyle, height: 6, animationDelay: "0.6s" }} />
            <span style={{ ...barStyle, height: 3, animationDelay: "0.8s" }} />
            <style>
                {`
                    @keyframes playingBar {
                        0%, 100% { transform: scaleY(1}); }
                        50% { transform: scaleY(${isPaused ? 1.3 : 2}); }
                    }
                `}
            </style>
        </span>
    );
}